/**
 * Created by Alex Aguilar on 7/20/2016.
 */
(function () {
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('countries', {
                parent: 'app',
                url: '/countries?page&size',
                params: {
                    page: "0",
                    size: "10"
                },
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/configGeneral/adminAirport/country/countries.html',
                        controller: 'countriesController',
                        controllerAs: 'vm',
                        resolve: {
                            tabs: ['tabService', function (tabService) {
                                return tabService.getTabAdminAirports('countries')
                            }],
                            countries: ['countryService', '$stateParams', function (countryService, $stateParams) {
                                return countryService.getCountries($stateParams.page, $stateParams.size);
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['country']);
                            }]
                        }
                    }
                }
            })
            .state('countryNew', {
                parent: 'app',
                url: '/country/new',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/configGeneral/adminAirport/country/newCountry.html',
                        controller: 'newCountryController',
                        controllerAs: 'vm',
                        resolve: {
                            tabs: ['tabService', function (tabService) {
                                return tabService.getTabAdminAirports('countries')
                            }],
                            continents: ['continentService', function (continentService) {
                                return continentService.getContinents()
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['country']);
                            }]
                        }
                    }
                }
            })
            .state('countryEdit', {
                parent: 'app',
                url: '/country/:id/edit',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/configGeneral/adminAirport/country/editCountry.html',
                        controller: 'editCountryController',
                        controllerAs: 'vm',
                        resolve: {
                            tabs: ['tabService', function (tabService) {
                                return tabService.getTabAdminAirports('countries')
                            }],
                            continents: ['continentService', function (continentService) {
                                return continentService.getContinents()
                            }],
                            country: ['countryService', '$stateParams', function (countryService, $stateParams) {
                                return countryService.getCountry($stateParams.id)
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['country']);
                            }]
                        }
                    }
                }
            })
            .state('countryDelete', {
                parent: 'countries',
                url: '/country/:id/delete',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/configGeneral/adminAirport/country/deleteCountry.html',
                        controller: 'deleteCountryController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            countryId: [function () {
                                return $stateParams.id
                            }],
                            country: ['countryService', function (countryService) {
                                return countryService.getCountry($stateParams.id)
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['country']);
                            }]
                        }
                    }).result.then(function () {
                        $state.go('countries', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }
})();
